import { render } from "./UserRegistrationComponent.vue?vue&type=template&id=54dc306c"
import script from "./UserRegistrationComponent.vue?vue&type=script&lang=js"
export * from "./UserRegistrationComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__